import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IListOfUsers } from '../../../../interface/administrator/admin';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../services/administrator/admin.service';
import { MaterialModule } from '../../../../shared/module/material.module';
import { CalAngularService } from '@cvx/cal-angular'; 
import { RoleService } from '../../../../shared/services/RoleService';
import { SharedServices } from '../../../../shared/services/shared.services';

@Component({
  selector: 'app-add-update-remove-user',
  imports: [MaterialModule, CommonModule,ReactiveFormsModule],
  templateUrl: './add-update-remove-user.component.html',
  styleUrl: './add-update-remove-user.component.css'
})
export class AddUpdateRemoveUserComponent {
  UserForm: FormGroup;
  isDeveloper:boolean = false;
  isLoading:boolean = false;
  loggedUserEmail: string = '';
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateRemoveUserComponent>,
    private http: HttpClient,
    private adminService: AdminService,
    private authService: CalAngularService,
    private roleService: RoleService,
    private sharedService:SharedServices
  ) {
    this.UserForm = this.fb.group({
      id: [{ value: data.user?.id, disabled: data.isEdit }],
      cai: [{ value: data.user?.cai || '', disabled: data.isEdit }],
      name: [data.user?.name || '', Validators.required],
      emailAddress: [{ value: data.user?.emailAddress || '', disabled: data.isEdit }, [Validators.required,Validators.email]],
      accessType: [data.user?.accessType || '', Validators.required]
    });
    if (this.UserForm.get('accessType')?.value === 'D' && !this.isDeveloper) {
      this.UserForm.get('accessType')?.disable();
    }
  }
  
  ngOnInit(): void {
    this.loggedUserEmail = this.authService.cvxClaimsPrincipal.userName ?? '';
    this.roleService.hasRole(['D'])
      .subscribe((data: boolean) => {
        this.isDeveloper = data;
        if (this.isDeveloper) {
          this.UserForm.get('accessType')?.enable();
        }
      });
      if (this.data.isEdit) {
        this.UserForm.patchValue(this.data.user);
        this.data.initialValues = this.UserForm.getRawValue();
    }
  }
  
  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.isLoading = true;
    if (this.UserForm.invalid) {
      this.sharedService.openModal('Message', 'Please enter all required information');
      this.isLoading = false;
      return;
    }
  
    const email = this.UserForm.get('emailAddress')?.value;
  
    if (!this.data.isEdit) {
      const emailExists = this.data.users.some((user: IListOfUsers) => user.emailAddress === email);
      if (emailExists) {
        this.sharedService.openModal('Message', 'Email already exists');
        this.isLoading = false;
        return;
      }
    }
  
    this.saveUser();
  }
  
  saveUser(): void {
    const initialFormValues = this.data.initialValues;
    if (this.data.isEdit) {
      const updatedUser = this.UserForm.getRawValue();
      if (JSON.stringify(initialFormValues) === JSON.stringify(updatedUser)) {
        this.sharedService.openModal('Message', 'No changes detected');
        this.isLoading = false;
        return;
      }
      this.adminService.updateUser(updatedUser).subscribe({
        next: response => {
          this.dialogRef.close(response);
          this.isLoading = false;
          this.sharedService.openModal('Message', 'Updated Successfully');
        },
        error: error => {
          console.error('Error updating user', error);
          this.isLoading = false;
        }
      });
    } else {
      if (this.UserForm.valid) {
        this.adminService.addUser(this.UserForm.value).subscribe({
          next: response => {
            this.dialogRef.close(true);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Added Successfully');
          },
          error: error => {
            console.error('Error adding user', error);
            this.isLoading = false;
          }
        });
      }
    }
  }
}